module.exports = __webpack_public_path__ + "media/images/spree/frontend/logo-b47efbe204f0ad2697fb6746a6b7ba37.svg";